// export const GET_ALL_COMPLETE_REQUEST = 'GET_ALL_COMPLETE_REQUEST';
export const SAVE_ALL_TEMPLATES = 'SAVE_ALL_TEMPLATES';
export const  GET_ALL_TEMPLATES = 'GET_ALL_TEMPLATES';
